import type { TovIconName } from './iconography';

export const DEFAULT_APP_NAVIGATION_ICON = 'dot-outline' as const;

export interface AppNavigationItem {
  id: string;
  label: string;
  href: string;
  summary: string;
  icon: TovIconName;
  disabled?: boolean;
  external?: boolean;
}

export interface AppNavigationSection {
  id: string;
  label: string;
  items: AppNavigationItem[];
}

export type AppNavigationItemInput = Omit<AppNavigationItem, 'icon'> & {
  icon?: TovIconName | string;
};

export type AppNavigationSectionInput = Omit<AppNavigationSection, 'items'> & {
  items: AppNavigationItemInput[];
};

export function withAppNavigationItemDefaults(
  item: AppNavigationItemInput,
): AppNavigationItem {
  return {
    icon: (item.icon ?? DEFAULT_APP_NAVIGATION_ICON) as TovIconName,
    ...item,
  } as AppNavigationItem;
}

export function withAppNavigationSectionDefaults(
  section: AppNavigationSectionInput,
): AppNavigationSection {
  return {
    ...section,
    items: section.items.map(withAppNavigationItemDefaults),
  };
}
